import { FlowRevision } from '../types/IContentRevision';
import { IGetItemsParams } from '../types/IGetItemsParams';
import { IGetItemsResult } from '../types/IGetItemsResult';
import { Request } from './Request';

export interface GetFlowVersionsParams extends IGetItemsParams {
}

export interface GetFlowVersionsResult extends IGetItemsResult {
  versions: FlowRevision[];
}

export class GetFlowVersionsRequest extends Request<GetFlowVersionsParams, GetFlowVersionsResult> {
  constructor(params: GetFlowVersionsParams) {
    super('getFlowVersions', params);
  }
}
